/** Compile beam — React enters, JetShake slits, optimised JS exits. */
export default function KeepFigure() {
  return (
    <div className="keep story-figure" aria-hidden="true">
      <div className="keep-field">
        <div className="keep-lane">
          <div className="keep-card keep-card--in">
            <span className="keep-card-kicker">Source</span>
            <span className="keep-card-title">Ordinary React</span>
            <span className="keep-card-code">{`<Counter />`}</span>
          </div>

          <div className="keep-beam">
            <span className="keep-beam-core" />
            <span className="keep-beam-label">JetShake</span>
          </div>

          <div className="keep-card keep-card--out">
            <span className="keep-card-kicker">Output</span>
            <span className="keep-card-title">Optimised JavaScript & HTML</span>
            <span className="keep-card-code">signals · direct DOM</span>
          </div>
        </div>

        <div className="keep-particles" aria-hidden="true">
          <span className="keep-particle" style={{ ["--i" as any]: 0 }} />
          <span className="keep-particle" style={{ ["--i" as any]: 1 }} />
          <span className="keep-particle" style={{ ["--i" as any]: 2 }} />
          <span className="keep-particle" style={{ ["--i" as any]: 3 }} />
          <span className="keep-particle" style={{ ["--i" as any]: 4 }} />
          <span className="keep-particle" style={{ ["--i" as any]: 5 }} />
          <span className="keep-particle" style={{ ["--i" as any]: 6 }} />
          <span className="keep-particle" style={{ ["--i" as any]: 7 }} />
          <span className="keep-particle" style={{ ["--i" as any]: 8 }} />
          <span className="keep-particle" style={{ ["--i" as any]: 9 }} />
          <span className="keep-particle" style={{ ["--i" as any]: 10 }} />
          <span className="keep-particle" style={{ ["--i" as any]: 11 }} />
        </div>
      </div>
    </div>
  );
}
